import type { TableColumnsType } from 'ant-design-vue'

export type TableDataType = {
  key: number
  name: string
  age: number
  street: string
  building: string
  number: number
  companyAddress: string
  companyName: string
  gender: string
}

export type recordDataType = {
  aggregateId?: string // 聚合ID
  dateTime?: string // 时间
  dbtId?: string
  appName?: string // 产品名
  settlementCurrency?: string // 币种
  thirdRevenue?: string // 三方-收入
  payRevenue?: string // 支付-收入
  diffRevenue?: string // 误差-收入
  diffRateRevenue?: string //  误差率 - 收入
  thirdOrderAmount?: string // 三方-付款订单数
  payOrderAmount?: string // 支付-付款订单数
  diffOrderAmount?: string // 误差-付款订单数
  diffRateOrderAmount?: string // 误差率-付款订单数
  thirdAmount?: string // 三方-订单金额
  payAmount?: string // 支付-订单金额
  diffAmount?: string // 误差-订单金额
  diffRateAmount?: string // 误差率 - 订单金额
  thirdRefundOrderAmount?: string // 三方-退款订单数
  payRefundOrderAmount?: string // 支付-退款订单数
  diffRefundOrderAmount?: string // 误差-退款订单数
  diffRateRefundOrderAmount?: string // 误差率-退款订单数
  thirdRefundAmount?: string // 三方-退款金额
  payRefundAmount?: string // 支付-退款金额
  diffRefundAmount?: string // 误差-退款金额
  diffRateRefundAmount?: string // 误差率-退款金额
  prodId?: string // 内购id
  regionCode?: string // 国家
}
export type searchData = {
  startDateTime?: string // 开始时间，默认7天前
  endDateTime?: string // 结束时间，默认昨天
  recentDay?: string // 最近天数，例如：7-1表示最近7天
  dynamic?: number // 是否使用动态时间：1-动态时间，0-静态时间
  fromDayToDay?: number // 是否从某固定日期至今：1-是，0-否
  useServerTime?: boolean // 是否使用服务器时间
  datePeriod?: string
  timeZone?: undefined | string
  dbtIdList?: string
  payChnl?: string | undefined
}

export const timeOptions = [
  { label: '天', value: 'day' },
  { label: '周', value: 'week' },
  { label: '月', value: 'month' },
  { label: '总计', value: 'sum' },
]
export const zoneOptions = [
  // { label: '北京时间（UTC+8）', value: 'Asia/Shanghai' },
  // { label: '世界协调时间（UTC）', value: 'UTC' },
  { label: '太平洋标准时间 (UTC-8)', value: 'UTC-8' },
  { label: '太平洋夏令时间 (UTC-7)', value: 'UTC-7' },
]
export const columns: TableColumnsType = [
  {
    title: '时间',
    dataIndex: 'dateTime',
    key: 'dateTime',
    fixed: 'left',
    width: '120px',
    sorter: (a: any, b: any) => {
      return new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime()
    },
  },
  {
    title: '产品名',
    dataIndex: 'appName',
    key: 'appName',
    fixed: 'left',
    width: '160px',
    sorter: (a, b) => {
      const nameA = a.appName ?? '' // 用空字符串代替 null/undefined
      const nameB = b.appName ?? ''
      return nameA.localeCompare(nameB)
    },
  },
  {
    title: '币种',
    dataIndex: 'settlementCurrency',
    key: 'settlementCurrency',
    width: '100px',
    fixed: 'left',
    sorter: (a, b) => a.settlementCurrency.localeCompare(b.settlementCurrency),
  },
  {
    title: '收入',
    children: [
      {
        title: 'IOS',
        dataIndex: 'thirdRevenue',
        key: 'thirdRevenue',
        width: '100px',
        sorter: (a, b) => a.thirdRevenue - b.thirdRevenue,
      },
      {
        title: '支付',
        dataIndex: 'payRevenue',
        key: 'payRevenue',
        width: '100px',
        sorter: (a, b) => a.payRevenue - b.payRevenue,
      },
      {
        title: '误差',
        dataIndex: 'diffRateRevenue',
        key: 'diffRateRevenue',
        width: '160px',
        sorter: (a, b) => {
          const aNum = parseFloat(a.diffRateRevenue.replace('%', ''))
          const bNum = parseFloat(b.diffRateRevenue.replace('%', ''))
          return aNum - bNum
        },
      },
    ],
    key: 'orderAmount',
  },
  {
    title: '付款订单数',
    children: [
      {
        title: 'IOS',
        dataIndex: 'thirdOrderAmount',
        key: 'thirdOrderAmount',
        width: '100px',
        sorter: (a, b) => a.thirdOrderAmount - b.thirdOrderAmount,
      },
      {
        title: '支付',
        dataIndex: 'payOrderAmount',
        key: 'payOrderAmount',
        width: '100px',
        sorter: (a, b) => a.payOrderAmount - b.payOrderAmount,
      },
      {
        title: '误差',
        dataIndex: 'diffRateOrderAmount',
        key: 'diffRateOrderAmount',
        width: '160px',
        sorter: (a, b) => {
          const aNum = parseFloat(a.diffRateOrderAmount.replace('%', ''))
          const bNum = parseFloat(b.diffRateOrderAmount.replace('%', ''))
          return aNum - bNum
        },
      },
    ],
  },
  {
    title: '订单金额',
    children: [
      {
        title: 'IOS',
        dataIndex: 'thirdAmount',
        key: 'thirdAmount',
        width: '100px',
        sorter: (a, b) => a.thirdAmount - b.thirdAmount,
      },
      {
        title: '支付',
        dataIndex: 'payAmount',
        key: 'payAmount',
        width: '100px',
        sorter: (a, b) => a.payAmount - b.payAmount,
      },
      {
        title: '误差',
        dataIndex: 'diffRateAmount',
        key: 'diffRateAmount',
        width: '160px',
        sorter: (a, b) => {
          const aNum = parseFloat(a.diffRateAmount.replace('%', ''))
          const bNum = parseFloat(b.diffRateAmount.replace('%', ''))
          return aNum - bNum
        },
      },
    ],
  },
  {
    title: '退款订单数',
    children: [
      {
        title: 'IOS',
        dataIndex: 'thirdRefundOrderAmount',
        key: 'thirdRefundOrderAmount',
        width: '100px',
        sorter: (a, b) => a.thirdRefundOrderAmount - b.thirdRefundOrderAmount,
      },
      {
        title: '支付',
        dataIndex: 'payRefundOrderAmount',
        key: 'payRefundOrderAmount',
        width: '100px',
        sorter: (a, b) => a.payRefundOrderAmount - b.payRefundOrderAmount,
      },
      {
        title: '误差',
        dataIndex: 'diffRateRefundOrderAmount',
        key: 'diffRateRefundOrderAmount',
        width: '160px',
        sorter: (a, b) => {
          const aNum = parseFloat(a.diffRateRefundOrderAmount.replace('%', ''))
          const bNum = parseFloat(b.diffRateRefundOrderAmount.replace('%', ''))
          return aNum - bNum
        },
      },
    ],
  },
  {
    title: '退款金额',
    children: [
      {
        title: 'IOS',
        dataIndex: 'thirdRefundAmount',
        key: 'thirdRefundAmount',
        width: '100px',
        sorter: (a, b) => a.thirdRefundAmount - b.thirdRefundAmount,
      },
      {
        title: '支付',
        dataIndex: 'payRefundAmount',
        key: 'payRefundAmount',
        width: '100px',
        sorter: (a, b) => a.payRefundAmount - b.payRefundAmount,
      },
      {
        title: '误差',
        dataIndex: 'diffRateRefundAmount',
        key: 'diffRateRefundAmount',
        width: '160px',
        sorter: (a, b) => {
          const aNum = parseFloat(a.diffRateRefundAmount.replace('%', ''))
          const bNum = parseFloat(b.diffRateRefundAmount.replace('%', ''))
          return aNum - bNum
        },
      },
    ],
  },
]

export const columnsThird: TableColumnsType = [
  {
    title: '时间',
    dataIndex: 'dateTime',
    key: 'dateTime',
    fixed: 'left',
    width: '120px',
  },
  {
    title: '国家',
    dataIndex: 'regionCode',
    key: 'regionCode',
    fixed: 'left',
    width: '160px',
  },
  {
    title: '内购ID',
    dataIndex: 'prodId',
    key: 'prodId',
    width: '180px',
    fixed: 'left',
  },
  {
    title: '订单金额',
    children: [
      {
        title: 'IOS',
        dataIndex: 'thirdAmount',
        key: 'thirdAmount',
        width: '100px',
      },
      {
        title: '支付',
        dataIndex: 'payAmount',
        key: 'payAmount',
        width: '100px',
      },
      {
        title: '误差',
        dataIndex: 'diffAmount',
        key: 'diffAmount',
        width: '160px',
      },
    ],
  },
  {
    title: '收入',
    children: [
      {
        title: 'IOS',
        dataIndex: 'thirdRevenue',
        key: 'thirdRevenue',
        width: '100px',
      },
      {
        title: '支付',
        dataIndex: 'payRevenue',
        key: 'payRevenue',
        width: '100px',
      },
      {
        title: '误差',
        dataIndex: 'diffRevenue',
        key: 'diffRevenue',
        width: '160px',
      },
    ],
    key: 'orderAmount',
  },
  {
    title: '付款订单数',
    children: [
      {
        title: 'IOS',
        dataIndex: 'thirdOrderAmount',
        key: 'thirdOrderAmount',
        width: '100px',
      },
      {
        title: '支付',
        dataIndex: 'payOrderAmount',
        key: 'payOrderAmount',
        width: '100px',
      },
      {
        title: '误差',
        dataIndex: 'diffOrderAmount',
        key: 'diffOrderAmount',
        width: '160px',
      },
    ],
  },
  {
    title: '退款订单数',
    children: [
      {
        title: 'IOS',
        dataIndex: 'thirdRefundOrderAmount',
        key: 'thirdRefundOrderAmount',
        width: '100px',
      },
      {
        title: '支付',
        dataIndex: 'payRefundOrderAmount',
        key: 'payRefundOrderAmount',
        width: '100px',
      },
      {
        title: '误差',
        dataIndex: 'diffRefundOrderAmount',
        key: 'diffRefundOrderAmount',
        width: '160px',
      },
    ],
  },
  {
    title: '退款金额',
    children: [
      {
        title: 'IOS',
        dataIndex: 'thirdRefundAmount',
        key: 'thirdRefundAmount',
        width: '100px',
      },
      {
        title: '支付',
        dataIndex: 'payRefundAmount',
        key: 'payRefundAmount',
        width: '100px',
      },
      {
        title: '误差',
        dataIndex: 'diffRateRefundAmount',
        key: 'diffRateRefundAmount',
        width: '160px',
      },
    ],
  },
]

export const columnsSingle: TableColumnsType = [
  {
    title: '时间',
    dataIndex: 'dateTime',
    key: 'dateTime',
  },
  {
    title: 'DBT订单号',
    dataIndex: 'orderNo',
    key: 'orderNo',
  },
  {
    title: '内购ID',
    dataIndex: 'prodId',
    key: 'prodId',
  },
  {
    title: '原币价格',
    dataIndex: 'oriPrice',
    key: 'oriPrice',
  },
  {
    title: '原币收入',
    dataIndex: 'oriRevenue',
    key: 'oriRevenue',
  },
  {
    title: '原币币种',
    dataIndex: 'oriCurrency',
    key: 'oriCurrency',
  },
  {
    title: '结算收入',
    dataIndex: 'revenue',
    key: 'revenue',
  },
  // {
  //   title: '结算币种',
  //   dataIndex: 'settlementCurrency',
  //   key: 'settlementCurrency',
  // },
  {
    title: '汇率',
    dataIndex: 'exchange',
    key: 'exchange',
  },
  {
    title: '国家',
    dataIndex: 'regionCode',
    key: 'regionCode',
  },
  {
    title: '订单类型',
    dataIndex: 'payStatus',
    key: 'payStatus',
  },
]

export const columnsIos: TableColumnsType = [
  {
    title: '时间',
    dataIndex: 'dateTime',
    key: 'dateTime',
  },
  {
    title: '内购ID',
    dataIndex: 'prodId',
    key: 'prodId',
  },
  {
    title: '订单数',
    dataIndex: 'prodNum',
    key: 'prodNum',
  },
  {
    title: '原币价格',
    dataIndex: 'oriPrice',
    key: 'oriPrice',
  },
  {
    title: '原币收入',
    dataIndex: 'oriRevenue',
    key: 'oriRevenue',
  },
  {
    title: '原币币种',
    dataIndex: 'oriCurrency',
    key: 'oriCurrency',
  },
  {
    title: '结算收入',
    dataIndex: 'revenue',
    key: 'revenue',
  },
  {
    title: '汇率',
    dataIndex: 'exchange',
    key: 'exchange',
  },
  {
    title: '国家',
    dataIndex: 'regionCode',
    key: 'regionCode',
  },
  {
    title: '订单类型',
    dataIndex: 'payStatus',
    key: 'payStatus',
  },
]
